import { motion } from "framer-motion";
import { ArrowRightIcon, BriefcaseIcon, UsersIcon } from "./Icons";
import { containerVariants, itemVariants } from "./Data";
import { Link } from "react-router-dom";

const DroneJobCareer = () => {
  return (
    <motion.div
      className="relative overflow-hidden bg-gradient-to-br from-sky-50 to-blue-100 rounded-3xl p-6 md:p-6 shadow-lg shadow-sky-100/50"
      variants={itemVariants}
    >
      <div className="relative text-center mb-8 md:mb-10">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-700 tracking-tight">
          Drone Jobs &{" "}
          <span className="relative inline-block">
            <span className="absolute inset-0 bg-sky-200/50 -skew-y-2 transform rounded-lg"></span>
            <span className="relative text-sky-600">Career Opportunities</span>
          </span>
        </h1>
        <p className="mt-4 text-base md:text-lg text-slate-600 max-w-xl mx-auto">
          Explore the future of aviation. Discover exciting career paths in the
          drone industry.
        </p>
      </div>

      <motion.div
        className="relative flex flex-col md:flex-row gap-6"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div
          className="flex-1 bg-white/70 backdrop-blur-sm rounded-2xl border border-slate-200 shadow-md p-6 sm:p-4 flex flex-col items-center text-center"
          variants={itemVariants}
          whileHover={{
            y: -8,
            scale: 1.03,
            boxShadow: "0px 15px 30px -10px rgba(71, 85, 105, 0.1)",
          }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="bg-sky-100 p-4 rounded-full mb-4 border border-sky-200">
            <BriefcaseIcon className="w-6 h-6 text-sky-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">
            For Job Seekers
          </h2>
          <p className="text-slate-600 text-base leading-relaxed mb-6 flex-grow">
            Discover featured drone industry jobs with easy applications,
            nationwide opportunities, and career growth support.
          </p>
          <Link to = "/jobs-hire-page">
         <motion.button
          className="mt-auto w-full bg-sky-500 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md shadow-sky-500/20 hover:bg-sky-600 transition-colors duration-300 flex items-center justify-center gap-2 border-none"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Find Jobs{" "}
          <motion.span whileHover={{ x: 5 }}>
            <ArrowRightIcon className="w-5 h-5" />
          </motion.span>
        </motion.button>
</Link>
        </motion.div>

        <motion.div
          className="flex-1 bg-white/70 backdrop-blur-sm rounded-2xl border border-slate-200 shadow-md p-6 sm:p-4 flex flex-col items-center text-center"
          variants={itemVariants}
          whileHover={{
            y: -8,
            scale: 1.03,
            boxShadow: "0px 15px 30px -10px rgba(71, 85, 105, 0.1)",
          }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <div className="bg-blue-100 p-4 rounded-full mb-4 border border-blue-200">
            <UsersIcon className="w-6 h-6 text-blue-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">
            For Employers
          </h2>
          <p className="text-slate-600 text-base leading-relaxed mb-6 flex-grow">
            Post your openings with ease, access a specialized talent pool, and
            recruit efficiently in the drone industry.
          </p>
          <Link to="/jobs-hire-page">
          <motion.button
            className="mt-auto w-full bg-blue-500 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md shadow-blue-500/20 hover:bg-blue-600 transition-colors duration-300 flex items-center justify-center gap-2 border-0 focus:outline-none focus:ring-0"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Post an Opening{" "}
            <motion.span whileHover={{ x: 5 }}>
              <ArrowRightIcon className="w-5 h-5" />
            </motion.span>
          </motion.button>
          </Link>

        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default DroneJobCareer;
